import { AppShell } from "./app";
import { createRoot } from "react-dom/client";
import { bindConsent, initCookieConsent } from "services/cookieConsent";
import { initI18n } from "services/i18n";
import { configLogger } from "services/logging";
import { disableProductAnalytics, initProductAnalytics } from "services/productAnalytics";
import assert from "utils/assert";
import { hydrateSessionStorage, saveBrowserTabId } from "utils/storage";

import "./styles/primitives.css";
import "./styles/semantic.css";
import "./components/adminUi/tokens.scss";
// Opt-in kit geometry for legacy native form markup inside ui/Dialog bodies —
// activate by adding `kit-form-controls` to a Dialog's className. Loaded here
// because kit components themselves must not import global stylesheets.
import "./components/ui/Dialog/formControls.css";
import "styles/index.css";

configLogger();

initI18n();
saveBrowserTabId();
hydrateSessionStorage();

const container = document.getElementById("root");
assert(container, "Root container not found");
createRoot(container).render(<AppShell />);

initCookieConsent();
bindConsent("statistics", initProductAnalytics, disableProductAnalytics);
